/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_elipse': {
    width: 205,
    height: 308,
    viewBox: '0 0 205 308',
    data: '<path pid="0" d="M102.5 205a102.504 102.504 0 0094.698-63.275A102.504 102.504 0 00141.725 7.802 102.502 102.502 0 00102.5 0v205z" _fill="#FFA600"/><path pid="1" d="M102.5 308A102.501 102.501 0 017.802 166.275 102.498 102.498 0 01102.5 103v205z" _fill="#24AE5F"/>'
  }
})
